// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volume_wrapper__LIF6S {
  --thumb-size: 12px;
  --track-height: 4px;
  --volume-slider-size: 60px;
  --margin-slider-button: 4px;
  --currentVolumeColor: var(--primaryColor);

  position: relative;
  display: flex;
  flex: none;
  align-items: center;
}

@media (forced-colors: active) {
    .volume_wrapper__LIF6S {
      --currentVolumeColor: ButtonText;
    }
  }

.volume_button__\\+mEad {
}

.volume_rangeInput__2M9J6 {
}
.volume_active__QBwDf {
}

.volume_sliderWrapper__cu5U2 {
  display: flex;
  align-items: center;
}

input[type='range'].volume_input__hUbEH {
  width: 1px; /* This cannot be 0 because Safari doesn't understand that */

  opacity: 0;

  transition-delay: 0.4s;
  transition-duration: 0.3s;
  transition-property: margin-left, width, opacity;
}

.volume_wrapper__LIF6S:hover .volume_input__hUbEH,
.volume_wrapper__LIF6S:focus-within .volume_input__hUbEH {
  width: var(--volume-slider-size);
  margin-left: var(--margin-slider-button);

  opacity: 1;

  transition-delay: 0s;
  transition-duration: 0.3s, 0.5s;
}

/* vertical slider */

.volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
  position: absolute;
  z-index: -10; /* This avoids the slider to show up on hover (of the slider itself) */
  bottom: calc(var(--volume-slider-size) - 8px);
  left: 50%;
  transform: translate(-50%) rotate(-90deg);

  padding: var(--thumb-size);
  border-radius: var(--thumb-size);

  opacity: 0;
  background: var(--controlbarBackgroundColor);

  transition-duration: 0.3s;
  transition-property: opacity;
}

.volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 input.volume_input__hUbEH[type='range'] {
    width: var(--volume-slider-size);
    margin-left: 0;
  }

@media (prefers-contrast: more) {
    .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
      border: 1px solid var(--borderColor);
    }
  }

@media (forced-colors: active) {
    .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
      border: 1px solid ButtonBorder;
    }
  }

.volume_wrapper__LIF6S:hover .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0,
.volume_wrapper__LIF6S:focus-within .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
  z-index: 1;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/volume/volume.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;;EAEzC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;AAOrB;;AALE;IACE;MACE,gCAAgC;IAClC;EACF;;AAGF;AAEA;;AAEA;AAEA;AACA;AAEA;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,4DAA4D;;EAExE,UAAU;;EAEV,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;EAChC,wCAAwC;;EAExC,UAAU;;EAEV,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,YAAY,EAAE,sEAAsE;EACpF,6CAA6C;EAC7C,SAAS;EACT,yCAAyC;;EAEzC,0BAA0B;EAC1B,gCAAgC;;EAEhC,UAAU;EACV,4CAA4C;;EAE5C,yBAAyB;EACzB,4BAA4B;AAkB9B;;AAhBE;IACE,gCAAgC;IAChC,cAAc;EAChB;;AAEA;IACE;MACE,oCAAoC;IACtC;EACF;;AAEA;IACE;MACE,8BAA8B;IAChC;EACF;;AAGF;;EAEE,UAAU;EACV,UAAU;AACZ","sourcesContent":[".wrapper {\n  --thumb-size: 12px;\n  --track-height: 4px;\n  --volume-slider-size: 60px;\n  --margin-slider-button: 4px;\n  --currentVolumeColor: var(--primaryColor);\n\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n\n  @media (forced-colors: active) {\n    & {\n      --currentVolumeColor: ButtonText;\n    }\n  }\n}\n\n.button {\n  composes: button from '../../styles/common.module.css';\n}\n\n.rangeInput {\n  composes: rangeInput from '../../styles/common.module.css';\n}\n.active {\n  composes: active from '../../styles/common.module.css';\n}\n\n.sliderWrapper {\n  display: flex;\n  align-items: center;\n}\n\ninput[type='range'].input {\n  width: 1px; /* This cannot be 0 because Safari doesn't understand that */\n\n  opacity: 0;\n\n  transition-delay: 0.4s;\n  transition-duration: 0.3s;\n  transition-property: margin-left, width, opacity;\n}\n\n.wrapper:hover .input,\n.wrapper:focus-within .input {\n  width: var(--volume-slider-size);\n  margin-left: var(--margin-slider-button);\n\n  opacity: 1;\n\n  transition-delay: 0s;\n  transition-duration: 0.3s, 0.5s;\n}\n\n/* vertical slider */\n\n.sliderWrapper.vertical {\n  position: absolute;\n  z-index: -10; /* This avoids the slider to show up on hover (of the slider itself) */\n  bottom: calc(var(--volume-slider-size) - 8px);\n  left: 50%;\n  transform: translate(-50%) rotate(-90deg);\n\n  padding: var(--thumb-size);\n  border-radius: var(--thumb-size);\n\n  opacity: 0;\n  background: var(--controlbarBackgroundColor);\n\n  transition-duration: 0.3s;\n  transition-property: opacity;\n\n  & input[type='range'].input {\n    width: var(--volume-slider-size);\n    margin-left: 0;\n  }\n\n  @media (prefers-contrast: more) {\n    & {\n      border: 1px solid var(--borderColor);\n    }\n  }\n\n  @media (forced-colors: active) {\n    & {\n      border: 1px solid ButtonBorder;\n    }\n  }\n}\n\n.wrapper:hover .sliderWrapper.vertical,\n.wrapper:focus-within .sliderWrapper.vertical {\n  z-index: 1;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `volume_wrapper__LIF6S`,
	"button": `volume_button__+mEad ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"rangeInput": `volume_rangeInput__2M9J6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["rangeInput"]}`,
	"active": `volume_active__QBwDf ${___CSS_LOADER_ICSS_IMPORT_0___.locals["active"]}`,
	"sliderWrapper": `volume_sliderWrapper__cu5U2`,
	"input": `volume_input__hUbEH`,
	"vertical": `volume_vertical__8wyL0`
};
module.exports = ___CSS_LOADER_EXPORT___;
